import { useEffect, useRef, type ReactNode } from 'react'
import { Icon } from './icons'

/** A side sheet over the table. It is the only large surface and only one is open at a time. */
export function Panel({ title, onClose, children }: { title: string; onClose: () => void; children: ReactNode }) {
  const close = useRef<HTMLButtonElement>(null)
  useEffect(() => {
    const previous = document.activeElement instanceof HTMLElement ? document.activeElement : null
    close.current?.focus()
    return () => { if (previous?.isConnected) previous.focus() }
  }, [])
  return <section className="tt-sheet" role="dialog" aria-label={title} onKeyDown={event => { if (event.key === 'Escape') { event.stopPropagation(); onClose() } }}>
    <div className="tt-sheet-header"><h2>{title}</h2><button ref={close} type="button" className="tt-icon-button" onClick={onClose} aria-label={`Close ${title}`}><Icon name="close"/></button></div>
    <div className="tt-sheet-body">{children}</div>
  </section>
}
